import { PayloadTypes, TrackActionTypes } from './types';
import { action } from 'typesafe-actions';

export const submitCollect = (payload: PayloadTypes) =>
  action(TrackActionTypes.SUBMIT_EVENT, payload);

export const trackCompleted = () =>
  action(TrackActionTypes.TRACK_EVENT_COMPLETED);
